import { GatsbyImage } from "gatsby-plugin-image";
import React from 'react';
import Stars from '../../../centers/ratings/liststars';

function InfoWindow(props) {
  return (
    <div className="bgm-container">
      {props.CarouselImages &&
      props.CarouselImages.list &&
      props.CarouselImages.list &&
      <div className="bgm-image"><GatsbyImage 
      alt={props.locationName}
      image={props.CarouselImages.window}
      /></div>}                
      <div className="bgm-content">
          <a className="bgm-title black-text-Genesis" 
          href={props.locationPath.toLowerCase()}
          target={(props.redirects === 1) ? `_blank` : `_self`}>{props.locationName}</a>
          <Stars 
            center={props.locationPath.toLowerCase()}
            allPracticemaxRatings={props.allPracticemaxRatings} /> 
          <div className="bgm-address">{props.locationAddress}</div>
          {props.distance != 0 ?
            <span className="cI-distance">
              <span className="black-text-Genesis">&gt;&gt;</span> {props.distance} miles
            </span>: null}
      </div>
    </div>  
  );
}

export default InfoWindow;